import { API } from 'aws-amplify';
import { awsApiName } from '../../shared/amplify/amplify-utils';
import { RequestBody } from '../../entity/core/request-body';
import { LineListTemplate } from '../../entity/model/line-list-template';

export default class LineListTemplateAgent {

  createLineListTemplate = async (organizationId: string, requestBody: RequestBody): Promise<LineListTemplate> => {
    return await API.post(awsApiName, `/organizations/${organizationId}/line-list-templates`, requestBody);
  }

  getLineListTemplates = async (organizationId: string): Promise<LineListTemplate[]> => {
    return await API.get(awsApiName, `/organizations/${organizationId}/line-list-templates`, {});
  }
} 